<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

import SustainfinityTable from "../../../components/SustainfinityTable.vue";

import su1 from "../components/SU1Pie.vue";
import su1Heat from "../components/SU1Heat.vue";
import greenDeal from "../components/GreenDeal.vue";
import su1SubColumn from "../components/SU1SubColumn.vue";
import su1TotalCompletedSurvey from "../components/SU1TotalCompletedSurvey.vue";
import wordCloud from "./WordCloud_su1_1.vue";
import wordCloud1 from "./WordCloud_su1_2.vue";
import axios from "axios";
import html2canvas from "html2canvas";

import d_SU1SubColumn from "./d_SU1SubColumn.vue";
import d_SU1Pie from "./d_SU1Pie.vue";
import d_SU1Heat from "./d_SU1Heat.vue";
import d_GreenDeal from "./d_GreenDeal.vue";

export default {
  name: "SDG Alignment Survey Results",
  components: {
    su1,
    su1Heat,
    greenDeal,
    su1SubColumn,
    su1TotalCompletedSurvey,
    wordCloud,
    wordCloud1,
    d_SU1SubColumn,
    d_SU1Pie,
    d_SU1Heat,
    d_GreenDeal,
    SustainfinityTable,
  },
  data() {
    return {
      textResultsSU1: [],
      textResultsFields: [
        {
          key: "firstname",
          label: i18n.t("su1Results.header.firstname"),
          width: 1,
        },
        {
          key: "surname",
          label: i18n.t("su1Results.header.surname"),
          width: 1,
        },
        {
          key: "role_name",
          label: i18n.t("su1Results.header.su1TextsAnswer1"),
          width: 1,
        },
        {
          key: "su1_texts_answer_1",
          label: i18n.t("su1Results.header.su1TextsAnswer1"),
          width: 1,
        },
        {
          key: "su1_texts_answer_2",
          label: i18n.t("su1Results.header.su1TextsAnswer2"),
          width: 1,
        },
        {
          key: "completed_on",
          label: i18n.t("su1Results.header.completedOn"),
          width: 1,
        },
      ],
      
      selectedPopupComponent: null,
      
      su1Surveys: [],
      selectedSurveyID: "",
      loading: false,

      selectedTab: 'graph',

      missingChecks: null,
    };
  },

  computed: {
    dashboardItemsMap() {
      return [
        { component: d_SU1Pie, popup_component: su1, visible: true, text: 'sdgAlignment', file_name: 'su1_piechart' },
        { component: d_SU1SubColumn, popup_component: su1SubColumn, visible: true, text: 'sdgSubCol', file_name: 'su1_subcolumn' },
        { component: d_SU1Heat, popup_component: su1Heat, visible: true, text: 'sdgSubHeat', file_name: 'su1_heat' },
        { component: d_GreenDeal, popup_component: greenDeal, visible: true, text: 'greenDeal', file_name: 'su1_greendeal' },
        { component: null, popup_component: wordCloud, visible: false, text: 'wordCloud_1', file_name: 'su1_wordcloud1' },
        { component: null, popup_component: wordCloud1, visible: false, text: 'wordCloud_2', file_name: 'su1_wordcloud2' },
      ];
    }
  },

  watch: {
    selectedSurveyID() {
      if (this.selectedSurveyID) {
        this.textsResults();
      }
    },

    texts(newVal) {
      if (newVal == true) {
        this.textsResults();
      }
    },

    selectedPopupComponent(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.$refs.graphPopup.openPopup();
      }
    }
  },

  mounted() {
    this.getMySurveys();
    this.getMissingGraphs();
    this.textsResults();
  },

  methods: {
    ...mapActions("results", [
      "getTextsResultsByCompanyID",
      "uploadReportGraph",
    ]),
    ...mapActions("surveys", ["getSU1Surveys"]),
    ...mapActions("reports", ["getGraphImagesInfo"]),

    getMissingGraphs() {
      const params = {
        company_id: this.$user.company_id
      }

      this.getGraphImagesInfo(params)
        .then(res => {
          this.missingChecks = res.data.check_images_exist;
        })
    },

    //getsu1surveyTRUE
    getMySurveys() {
      this.su1Surveys = [];
      const params = {
        created_by: this.$user.user_id,
        company_id: this.$user.company_id,
        is_deleted: false,
      };

      this.loading = true;
      this.getSU1Surveys(params)
        .then((res) => {
          this.su1Surveys = res.data;
          this.openingSurvey(res.data);
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 150);
        })
    },
    
    textsResults() {
      this.textResultsSU1 = [];
      let params = {
        company_id: this.$user.company_id,
        su1_survey_id: this.selectedSurveyID,
        is_deleted: "false",
      };
      this.getTextsResultsByCompanyID(params)
        .then((res) => {
          for (let idx = 0; idx < res.data.length; idx++) {
            const element = res.data[idx];
            this.textResultsSU1.push({
              idx: idx,
              ...element,
            });
          }
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
    },
    
    openingSurvey(surveys) {
      surveys = surveys.sort((a, b) => b.su1_survey_id - a.su1_survey_id);
      this.selectedSurveyID = surveys[0].su1_survey_id;
    },

    selectGraph(graph) {
      this.selectedPopupComponent = graph;
    },

    downloadExcel() {
      let params = {
        su1_survey_id: this.selectedSurveyID,
        company_id: this.$user.company_id,
        created_by: this.$user.user_id,
      };
      axios
        .post(`/api/su1result/getsu1surveyresults`, params, {
          responseType: "blob",
        })
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `SDG Alignment Report - ${new Date().toLocaleDateString()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: response.data,
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },

    convertCanvasToFile(canvas, filename) {
      return new Promise((resolve, reject) => {
        try {
          canvas.toBlob((blob) => {
            const file = new File([blob], filename, { type: "image/png" });
            resolve(file);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    sendToBackend(screenshotFile) {
      const formData = new FormData();
      formData.append("files", screenshotFile);
      formData.append("user_id", this.$user.user_id);
      formData.append("company_id", this.$user.company_id);
      formData.append("survey_id", this.selectedSurveyID);
      formData.append("language", localStorage.getItem('lang') || 'en');
      this.uploadReportGraph(formData)
        .then((response) => {
          this.$notify('success', response.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.$refs.graphPopup.startHideProcess();
        })
    },

    confirmGraph() {
      const containerElement = this.$refs.screenshotArea.$el;
      // The popup chart is rendered in the UI language, so a Turkish render is saved as the "_tr" graph.
      const language = localStorage.getItem('lang') || 'en';
      const fileName = String(this.selectedPopupComponent.file_name).concat(language === 'tr' ? '_tr' : '', '.png');
      html2canvas(containerElement)
        .then((canvas) => {
          this.convertCanvasToFile(canvas, fileName)
            .then((file) => {
              this.sendToBackend(file);
            })
        })
    },

    handleMyTabs(tab) {
      this.selectedTab = tab;
    },
    
    startLoading(timeout) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, timeout);
    },
  },
};
</script>

<template>
  <div class="p-3">
    <loading-spinner v-if="loading" :container="true" color="var(--sustainfinity-green)" />
    <div v-else>
      <div>
        <div class="flex-all-centered-row" style="justify-content: flex-start; padding-bottom: 1.5em;">
          <select class="sust-btn sust-btn-green" style="max-height: 35px; min-width: 6em; margin-right: 1em;"
            v-model="selectedSurveyID" @change="startLoading(200)"
          >
            <option v-for="survey in su1Surveys"
              :value="survey.su1_survey_id"
              :key="survey.su1_survey_id"
            >
              {{ survey.su1_survey_name }}
            </option>
          </select>
          <button class="sust-btn sust-btn-blue flex-all-centered-row" 
            style="max-height: 35px; width: fit-content;"
            @click="downloadExcel()">
            {{ $t("su1Results.createExcel") }}
            <i class="fa-solid fa-file-excel" style="margin-left: 1em;"></i>
          </button>
        </div>

        <div class="tab-rounded">
          <div class="tab-btn" :class="{ 'active': selectedTab === 'graph' }" @click="handleMyTabs('graph')">
            {{ $t('su1Results.graphResults') }}
          </div>
          <div class="tab-btn" :class="{ 'active': selectedTab === 'text' }" @click="handleMyTabs('text')">
            {{ $t('su1Results.textResults') }}
          </div>
        </div>

        <div v-if="selectedTab === 'graph'" class="charts-container">
          <div
            v-for="(item, idx) in dashboardItemsMap" :key="idx"
            class="chart-box"
            @click="selectGraph(item)"
          >
            <div class="content">
              <h1>
                {{ $t(`su1Results.resultsPage.page.${item.text}.title`) }}
              </h1>
              <p>
                {{ $t(`su1Results.resultsPage.page.${item.text}.description`) }}
              </p>
            </div>
            <component v-if="item.visible" :is="item.component" :selectedSurveyID="selectedSurveyID" />
            <div v-else class="flex-all-centered-row">
              <img src="/images/foul.png" alt="Wordcloud">
            </div>
          </div>
        </div>

        <div v-else-if="selectedTab === 'text'">
          <sustainfinity-table 
            :headers="textResultsFields"
            :items="textResultsSU1"
            :iterator="'idx'"
          />
        </div>

        <sust-popup
          ref="graphPopup"
          :title="selectedPopupComponent ? $t(`su1Results.resultsPage.page.${selectedPopupComponent.text}.title`) : ''"
          size="xl"
          :footer="false"
          @onHide="selectGraph(null)"
        >
        <div class="flex-all-centered-col">
          <div class="flex-all-centered-row" style="justify-content: flex-end;">
            <button class="sust-btn sust-btn-blue"
              @click="confirmGraph()"
            >
              Confirm Graph
            </button>
          </div>
          <component 
            :style="{width: selectedPopupComponent.text === 'sdgSubCol' ? '85%' : '60%'}"
            v-if="selectedPopupComponent" 
            :is="selectedPopupComponent.popup_component" 
            :selectedSurveyID="selectedSurveyID"
            ref="screenshotArea"
            class="background-image"
          />
        </div>
        </sust-popup>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tab-rounded {
  border-radius: 200px;
  overflow: hidden;
  border: thin solid var(--sustainfinity-navy);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  margin-bottom: 1em;
}

.tab-btn {
  background-color: whitesmoke;
  color: var(--sustainfinity-navy);
  width: 100%;
  text-align: center;
  padding: .25em;

  transition: all 150ms;
  cursor: pointer;
}

.tab-btn:hover {
  background-color: lightgray;
}

.tab-btn.active {
  background-color: var(--sustainfinity-navy);
  color: whitesmoke;
  pointer-events: none;
}

.charts-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  align-content: flex-start;

  > .chart-box {
    background-color: var(--sustainfinity-navy) !important;
    border-radius: 1em;
    box-shadow: 0 .25em .5em .1em gray;
    width: 32%;
    margin-bottom: 2em;
    padding: 2em;
    cursor: pointer;

    transition: background-color 150ms, scale 250ms;

    &:hover {
      background-color: var(--sustainfinity-navy--hover);
      scale: 1.03;
    }
    
    > .content {
      text-align: center;
      color: whitesmoke !important;

      > h1 {
        font-size: 1.5rem;
      }
      
      > p {
        font-size: 1.05rem;
      }
    }
  }
}

.save-graph-button {
  position: absolute;
  top: 0;
  right: 0;
  margin: .5em;

  max-width: fit-content;
  max-height: fit-content;

  z-index: 99;
}

.background-image::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/images/sustainfinity_512x512.png");
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: -1
}

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

img {
  width: 50%;
  vertical-align: middle;
}
</style>
